module.exports = __webpack_public_path__ + "static/img/card2.792f2d8f.png";